const observer = new MutationObserver((_, obs) => {
  const images = document.querySelectorAll('.mw-option-select img.beside-image');
  const selectEl = document.querySelector('.mw-options-container .mw-option-select:nth-child(2) select');
  if (!images.length || !selectEl) return;

  images.forEach(img => {
    img.addEventListener('click', () => {
      const valueId = img.dataset.valueId;
      images.forEach(i => i.dataset.selected = 'false');
      img.dataset.selected = 'true';

      const opt = [...selectEl.options].find(o => o.dataset.valueId === valueId);
      if (opt) {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event('change'));
      }
    });
  });
  
  selectEl.addEventListener('change', () => {
    const selectedId = selectEl.selectedOptions[0]?.dataset.valueId || '';
    images.forEach(img => {
      img.dataset.selected = (img.dataset.valueId === selectedId).toString();
    });
  });
  
  setInterval(() => {
    const selectedImg = [...images].find(img => img.dataset.selected === 'true');
    const visible = selectedImg && window.getComputedStyle(selectedImg).display !== 'none';

    if (selectedImg && !visible) {
      selectedImg.dataset.selected = 'false';
      selectEl.selectedIndex = 0;
      selectEl.dispatchEvent(new Event('change'));
    } else if (selectedImg) {
      const matchOpt = [...selectEl.options].find(o => o.dataset.valueId === selectedImg.dataset.valueId);
      if (matchOpt && selectEl.value !== matchOpt.value) {
        selectEl.value = matchOpt.value;
        selectEl.dispatchEvent(new Event('change'));
      }
    }
  }, 300);

  selectEl.dispatchEvent(new Event('change'));
  obs.disconnect();
});
observer.observe(document.body, { childList: true, subtree: true });



document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const productCards = document.querySelectorAll(".product-card");
  const selectedFiltersElement = document.querySelector(".text-subdued");

  const activeFilters = {
    color: [],
    size: [],
    width: []
  };

  filterButtons.forEach(button => {
    button.addEventListener("click", function () {
      const filterType = this.dataset.filterType;
      const filterValue = this.dataset.filterValue;

      this.classList.toggle("active");

      if (activeFilters[filterType].includes(filterValue)) {
        activeFilters[filterType] = activeFilters[filterType].filter(val => val !== filterValue);
      } else {
        activeFilters[filterType].push(filterValue);
      }

      filterProducts();
      updateSelectedFilters();
    });
  });

  function filterProducts() {
    productCards.forEach(card => {
      const productTags = card.dataset.tags.split(",");

      let show = true;

      for (let type in activeFilters) {
        const selected = activeFilters[type];
        if (selected.length > 0) {
          const hasMatch = selected.some(val => productTags.includes(val));
          if (!hasMatch) {
            show = false;
            break;
          }
        }
      }

      card.style.display = show ? "block" : "none";
    });
  }

  function updateSelectedFilters() {
    const selectedText = Object.values(activeFilters)
      .flat()
      .map(val => val.charAt(0).toUpperCase() + val.slice(1))
      .join(', ');

    selectedFiltersElement.textContent = selectedText || 'None';
  }
});

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.jdgm-carousel-item__product').forEach(function(item) {
        var wrapper = document.createElement('div');
        wrapper.classList.add('custom-wrapper', 'new-class');
        item.parentNode.replaceChild(wrapper, item);
        wrapper.appendChild(item);
        var reviewTitle = item.closest('.jdgm-carousel-item').querySelector('.jdgm-carousel-item__review-title');
        if (reviewTitle) {
            wrapper.appendChild(reviewTitle);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach(card => {
    const swatchContainer = card.querySelector('#swatch-container');
    const showMoreBtn = card.querySelector('#show-more-btn');
    const switchPart = card.querySelector('.product-content-row .h-stack');

    if (!swatchContainer || !showMoreBtn) return;

    let isMobile = window.innerWidth <= 768;
    const desktopLimit = parseInt(swatchContainer.dataset.desktopLimit, 10) || 6;
    const mobileLimit = parseInt(swatchContainer.dataset.mobileLimit, 10) || 3;

    function updateSwatches() {
      const swatches = swatchContainer.querySelectorAll('.swatch');
      const visibleLimit = isMobile ? mobileLimit : desktopLimit;

      swatches.forEach((swatch, index) => {
        swatch.style.display = index < visibleLimit ? 'block' : 'none';
      });

      const hiddenCount = swatches.length - visibleLimit;
      if (hiddenCount > 0) {
        showMoreBtn.style.display = 'block';
        showMoreBtn.innerHTML = `+ ${hiddenCount} More`;
      } else {
        showMoreBtn.style.display = 'none';
      }

      showMoreBtn.classList.remove('expanded');
      swatchContainer.classList.remove('active');
      switchPart.classList.remove('active');
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        const swatches = swatchContainer.querySelectorAll('.swatch');
        const isExpanded = showMoreBtn.classList.contains('expanded');
        if (isExpanded) {
          updateSwatches();
        } else {
          swatches.forEach(swatch => (swatch.style.display = 'block'));
          showMoreBtn.textContent = '- Less';
          showMoreBtn.classList.add('expanded');
          swatchContainer.classList.add('active');
          switchPart.classList.add('active');
        }
      });
    }

    window.addEventListener('resize', function () {
      const newIsMobile = window.innerWidth <= 768;
      if (newIsMobile !== isMobile) {
        isMobile = newIsMobile;
        updateSwatches();
      }
    });

    updateSwatches();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.jdgm-carousel__item-container .jdgm-carousel__item-wrapper');

  items.forEach(item => {
    item.classList.remove('jdgm-carousel__item-wrapper'); 
    item.classList.add('wrapper');
  });
});

const swiper = new Swiper('#mega_menu', {
  spaceBetween: 8,
    freeMode: {
    enabled: true,
    sticky: false,
    momentumBounce: false,
  },
  mousewheel: {
    enabled: true,
    sensitivity: 8,
  },
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar"
  },
    breakpoints: {
    '1366': {
      slidesPerView: 7,
    },
    '768': {
      slidesPerView: 3,
    },
    '320': {
      slidesPerView: 2,
      spaceBetween: 16,
    },
  }
});

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".jdgm-carousel-item__product");

    items.forEach(function (item) {
        if (!item.querySelector("img")) {
            const defaultImage = document.createElement("img");
            defaultImage.src = "https://cdn.shopify.com/s/files/1/2866/6692/files/user-default.jpg";
            defaultImage.alt = "Default Image";

            item.appendChild(defaultImage);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.jdgm-carousel-item');
  const maxVisibleItems = 4;

  function updateVisibleItems() {
    items.forEach((item, index) => {
      if (index < maxVisibleItems) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    });
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }
  const parentContainer = document.querySelector('.wrapper');

  if (!parentContainer || items.length === 0) {
    return;
  }

  if (items.length > maxVisibleItems && isMobile()) {
    const showAllButton = document.createElement('button');
    showAllButton.textContent = 'View more reviews';
    showAllButton.classList.add('show-all-btn');
    showAllButton.style.marginTop = '10px';
    showAllButton.style.cursor = 'pointer';

    parentContainer.appendChild(showAllButton);

    updateVisibleItems();

    showAllButton.addEventListener('click', function () {
      items.forEach(item => {
        item.style.display = 'flex';
      });
      showAllButton.style.display = 'none';
    });
  }

  window.addEventListener('resize', function () {
    if (!parentContainer || items.length === 0) {
      return;
    }

    if (isMobile()) {
      if (items.length > maxVisibleItems && !parentContainer.querySelector('.show-all-btn')) {
        const showAllButton = document.createElement('button');
        showAllButton.textContent = 'View more reviews';
        showAllButton.classList.add('show-all-btn');
        showAllButton.style.marginTop = '10px';
        showAllButton.style.cursor = 'pointer';

        parentContainer.appendChild(showAllButton);

        updateVisibleItems();

        showAllButton.addEventListener('click', function () {
          items.forEach(item => {
            item.style.display = 'flex';
          });
          showAllButton.style.display = 'none';
        });
      }
    } else {
      const showAllButton = parentContainer.querySelector('.show-all-btn');
      if (showAllButton) {
        showAllButton.style.display = 'none';
      }
    }
  });
});

// add ring color arrow btn
document.addEventListener('DOMContentLoaded', function () {
    function appendButtons() {
        var container = document.querySelector('[data-option="Ring Color"]');
        if (container && !container.querySelector('.custom-nav')) {
            var navWrapper = document.createElement('div');
            navWrapper.classList.add('custom-nav');

            var prevBtn = document.createElement('a');
            prevBtn.href = "javascript:void(0)";
            prevBtn.classList.add('custom-prev');
            prevBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="20" height="20">
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>
            `;

            var nextBtn = document.createElement('a');
            nextBtn.href = "javascript:void(0)";
            nextBtn.classList.add('custom-next');
            nextBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="20" height="20">
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>
            `;

            navWrapper.appendChild(prevBtn);
            navWrapper.appendChild(nextBtn);
            container.appendChild(navWrapper);

            prevBtn.addEventListener('click', function (e) {
                e.preventDefault();
                container.scrollBy({ left: -200, behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', function (e) {
                e.preventDefault();
                container.scrollBy({ left: 200, behavior: 'smooth' });
            });
        }
    }
    setTimeout(appendButtons, 2000);
});


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        let targetElement = document.querySelector('.cl-po--option[data-option="Personalize-group"]');

        if (targetElement) {
            let newDiv = document.createElement("div");
            newDiv.classList.add("custom-personalize");

            let img1 = document.createElement("img");
            img1.src = "https://cdn.shopify.com/s/files/1/2866/6692/files/minus.svg";
            img1.alt = "second Image";
            img1.classList.add("second-image");

            let img2 = document.createElement("img");
            img2.src = "https://cdn.shopify.com/s/files/1/2866/6692/files/plus.svg";
            img2.alt = "first Image";
            img2.classList.add("first-image");

            let paragraph = document.createElement("p");
            paragraph.textContent = "Personalize This Ring";

            newDiv.appendChild(img1);
            newDiv.appendChild(img2);
            newDiv.appendChild(paragraph);

            targetElement.prepend(newDiv);

            let groupElement = targetElement.querySelector(".cl-po--group");
            
            if (groupElement) {
                groupElement.style.display = "block";
            }

            newDiv.addEventListener("click", function () {
                if (groupElement) {
                    if (groupElement.style.display === "none") {
                        groupElement.style.display = "block";
                    } else {
                        groupElement.style.display = "none";
                    }
                }

                targetElement.classList.toggle("active");
            });
        }
    }, 2000);
});

setTimeout(function () {
    const btn1 = document.getElementById("larg_btn");
    const btn2 = document.getElementById("medium_btn");
    const collectionList = document.querySelector(".collection-list");

    if (!btn1 || !btn2 || !collectionList) {
        return;
    }

    collectionList.classList.add("grid-large");
    collectionList.classList.remove("grid-medium");

    btn1.addEventListener("click", function () {
      collectionList.classList.add("grid-medium");
      collectionList.classList.remove("grid-large");
      btn1.classList.add("is-active");
      btn2.classList.remove("is-active");
    });

    btn2.addEventListener("click", function () {
      collectionList.classList.add("grid-large");
      collectionList.classList.remove("grid-medium");
      btn1.classList.remove("is-active");
      btn2.classList.add("is-active");
    });

}, 1000);


document.addEventListener('click', function (e) {
  if (e.target.closest('.product-info__block-item .open-sizing-guide')) {
    e.preventDefault();
    document.body.classList.add('active');
  }

  if (e.target.closest('.sizing-guide__close')) {
    e.preventDefault();
    setTimeout(() => {
      document.body.classList.remove('active');
    }, 500);
  }
});

document.addEventListener("click", function(e) {
  const summary = e.target.closest(".header__menu-disclosure summary");
  if (!summary) return;

  const parent = summary.closest(".header__menu-disclosure");
  if (!parent) return;

  parent.classList.toggle("is-open");

  if (parent.classList.contains("is-open")) {
    parent.removeAttribute("open");
    parent.setAttribute("aria-expanded", "true");
  } else {
    parent.setAttribute("open", "");
    parent.setAttribute("aria-expanded", "false");
  }
});


document.addEventListener("DOMContentLoaded", function () {
  function moveSizingGuide() {
    var guide = document.querySelector(".open-sizing-guide");
    var target = document.querySelector('[data-option^="Ring Size"] .cl-po--label');

    if (guide && target) {
      if (!target.contains(guide)) {
        target.appendChild(guide);
      }
    } else {
      setTimeout(moveSizingGuide, 500);
    }
  }

  moveSizingGuide();
});


document.addEventListener("DOMContentLoaded", function () {
  function addLink() {
    var inside = document.querySelector('[data-option*="Inside Text"]');
    var outside = document.querySelector('[data-option*="Outside Text"]');

    if (inside && !inside.querySelector(".engraving-btn")) {
      var link = document.createElement("a");
      link.href = "javascript:void(0);";
      link.textContent = "Show me more ideas!";
      link.classList.add("engraving-btn");
      inside.appendChild(link);
    }

    if (outside && !outside.querySelector(".engraving-btn")) {
      var link = document.createElement("a");
      link.href = "javascript:void(0);";
      link.textContent = "Show me more ideas!";
      link.classList.add("engraving-btn");
      outside.appendChild(link);
    }
  }

  addLink();

  const observer = new MutationObserver(() => {
    addLink();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});



// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(function(){
//     var link = document.createElement("a");
//     link.href = "javascript:void(0);";
//     link.textContent = "Show me more ideas!";
//     link.classList.add("engraving-btn");

//     var inside = document.querySelector('[data-option="Inside Text"]');
//     var outside = document.querySelector('[data-option="Outside Text"]');

//     if (inside) inside.appendChild(link.cloneNode(true));
//     if (outside) outside.appendChild(link.cloneNode(true));
//   }, 1000);
// });

document.addEventListener("DOMContentLoaded", function () {
  let path = window.location.pathname;

  if (path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  let pageName = path.split("/").pop() || "home";

  pageName = pageName.replace(/[^a-z0-9_-]/gi, "").toLowerCase();
  document.body.classList.add("page-" + pageName);
});

document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        if (event.target.closest(".filter_btn")) {
            const safeSticky = document.querySelector("#safe-sticky");
            const collectionToolbar = document.querySelector(".collection-toolbar");

            if (safeSticky) {
                safeSticky.style.display = "block"; 
            }
            if (collectionToolbar) {
                collectionToolbar.classList.add("active-toolbar");
            }

            const activeFacetsContainer = document.getElementById("active-facets");

            // if (activeFacetsContainer) {
            //     const removableFacets = activeFacetsContainer.querySelectorAll(".removable-facet");

            //     if (removableFacets.length === 0) {
            //         document.body.classList.add("filter-active");
            //     } else {
            //         document.body.classList.remove("filter-active");
            //     }
            // }
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        if (event.target.closest("#filter-close") || event.target.closest("#footer-btn")) {
            const safeSticky = document.querySelector("#safe-sticky");
            const collectionToolbar = document.querySelector(".collection-toolbar");

            if (safeSticky) {
                safeSticky.style.display = "none"; 
            }
            if (collectionToolbar) {
                collectionToolbar.classList.remove("active-toolbar"); 
            }
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
  let activeFacets = document.querySelector('#active-facets');
  let observer = null;
  let pageObserver = null;

  function toggleBodyClass() {
    if (!activeFacets) return;
    const hasActiveTag = activeFacets.querySelector('.active-tag') !== null;
    document.body.classList.toggle('active-filter', hasActiveTag);
  }

  function observeActiveFacets() {
    if (observer) observer.disconnect();

    if (activeFacets) {
      observer = new MutationObserver(toggleBodyClass);
      observer.observe(activeFacets, { childList: true, subtree: true });
      toggleBodyClass();
    }
  }

  pageObserver = new MutationObserver(() => {
    const newFacets = document.querySelector('#active-facets');
    if (newFacets && newFacets !== activeFacets) {
      activeFacets = newFacets;
      observeActiveFacets();
    }
  });

  pageObserver.observe(document.body, { childList: true, subtree: true });

  observeActiveFacets();
});





